import { render, staticRenderFns } from "./TransportationHoldingGroup.vue?vue&type=template&id=618bbced&scoped=true&"
import script from "./TransportationHoldingGroup.vue?vue&type=script&lang=js&"
export * from "./TransportationHoldingGroup.vue?vue&type=script&lang=js&"
import style0 from "./TransportationHoldingGroup.vue?vue&type=style&index=0&id=618bbced&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618bbced",
  null
  
)

export default component.exports